export default {
  tus: null as any,
};
